import { color } from "./../../../node_modules/@types/d3-color/index.d";
import styled from "styled-components";
import { motion } from "framer-motion";

export const DashboardContainer = styled.div`
  padding: 3rem;
  height: 100%;
`;

export const TapMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  border-bottom: 1px solid #ececec;
  width: 100%;
`;

export const TapMenuBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex: 1;
`;

export const TapMenuItem = styled(motion.div)`
  width: 16.35rem;
  padding: 1.8rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 2.2rem;
  letter-spacing: -0.06rem;
  color: #a1a1a1;
  position: relative;
  cursor: pointer;
  &.isActive {
    color: black;
  }
  .manu-name {
    display: flex;
    gap: 0.4rem;
    span.dot {
      padding-top: 0.4rem;
      width: 0.6rem;
      height: 0.6rem;
      background-color: #ed2115;
      display: flex;
      border-radius: 0.6rem;
    }
  }
`;

export const UnderLine = styled(motion.div)`
  position: absolute;
  bottom: -1px;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: black;
  border-radius: 2px;
`;

export const TabWrapper = styled.div`
  height: calc(100% - 5.7rem);
`;

export const TapItem = styled(motion.div)`
  height: 100%;
`;

export const ChartWrap = styled.div`
  display: flex;
  padding: 2.4rem 0;
  gap: 2.4rem;
`;

export const ChartBox = styled.div`
  min-width: 71.4rem;
  width: 100%;
  border: 1px solid #cecece;
  border-radius: 0.5rem;
  padding: 2.4rem;
`;

export const PieChartBox = styled.div`
  width: 100%;
  border: 1px solid #cecece;
  border-radius: 0.5rem;
  padding: 2.4rem;
`;

export const ChartItemWrap = styled.div`
  position: relative;
  h4 {
    font-size: 2rem;
    line-height: 2.4rem;
    font-weight: 700;
  }
`;

export const PieChartLegendWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  top: 9rem;
  .inner {
    text-align: center;
    strong {
      font-size: 2rem;
    }
    .item-boxs {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.4rem;
      .box {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        margin-right: 0.4rem;
        &.man {
          background-color: #5b93ff;
        }
        &.woman {
          background-color: #f27496;
        }
      }
      span {
        font-size: 1.3rem;
      }
    }
  }
`;

export const PieChartBarWrap = styled.div`
  margin-top: 2rem;
  .items {
    display: flex;
    align-items: center;
    margin: 0.6rem 0;
    .left-txt {
      width: 3rem;
      text-align: right;
      font-size: 1.2rem;
      color: #5b93ff;
    }
    .left-bar {
      flex: 1;
      margin: 0 0.4rem;
      background-color: #e6f0ff;
      height: 0.8rem;
      position: relative;
    }
    .center-txt {
      width: 4rem;
      text-align: center;
      font-size: 1.2rem;
    }
    .right-bar {
      flex: 1;
      margin: 0 0.4rem;
      background-color: #ffe8ee;
      height: 0.8rem;
      position: relative;
    }
    .right-txt {
      width: 3rem;
      text-align: left;
      font-size: 1.2rem;
      color: #f27496;
    }
  }
`;

export const DashboardSearchWrap = styled.div`
  padding: 2.4rem 1.6rem;
  display: flex;
  gap: 1.6rem;
`;

export const DateBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const DatePickerWrap = styled.div`
  width: 100%;
  position: relative;
  .search-l-r-btn {
    position: absolute;
    border: none;
    background-color: transparent;
    display: flex;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    &.left {
      left: 0.4rem;
    }
    &.right {
      right: 0.4rem;
    }
    &:disabled {
      svg {
        path {
          stroke: #cecece;
        }
      }
    }
  }
`;

export const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  span {
    margin: 0 1rem;
    font-size: 1.4rem;
    font-weight: 400;
    transform: translateY(1px);
    color: ${(props) => props.theme.joinLabelColor};
  }
  .inner {
    position: relative;
    width: 100%;
    .react-datepicker-wrapper {
      width: 100%;
    }
    .react-datepicker-wrappers {
      border: 1px solid #aeaeae;
      border-radius: 1rem;
      overflow: hidden;
      box-shadow: 1px 1px 4px 0px #00000040;
    }
    .search-input {
      padding: 1.3rem 8.4rem;
      width: 100%;
      text-align: center;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 2rem;
      border: 1px solid #cbcbcb;
      border-radius: 0.5rem;
      box-shadow: 1px 1px 4px 0px #00000040;
    }
    .react-datepicker {
      font-size: 1.2rem;
      font-family: "SpoqaHanSansNeo", sans-serif;
      font-weight: 400;
      border-radius: 0;
      border: 0;
      .react-datepicker__header {
        background-color: white;
      }
      .react-datepicker__month-container {
        background-color: #fafafa;
      }
      .react-datepicker__current-month,
      .react-datepicker-time__header,
      .react-datepicker-year-header {
        margin-top: 1rem;
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .react-datepicker__day-name,
      .react-datepicker__day,
      .react-datepicker__time-name {
        width: 4rem;
        line-height: 4rem;
      }
      .react-datepicker__day--selected,
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--selected,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--selected,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--selected,
      .react-datepicker__year-text--in-selecting-range,
      .react-datepicker__year-text--in-range {
        border-radius: 0.5rem;
        background-color: #225298;
        color: ${(props) => props.theme.textWhiteColor};
      }
      .custom-daily-range {
        background-color: rgba(118, 161, 225, 0.4);
        border-radius: 0.5rem;
        &.react-datepicker__day--selected {
          background-color: #225298;
        }
      }
      .react-datepicker__day--keyboard-selected {
        background-color: transparent;
        color: black;
      }
      .react-datepicker__navigation {
        top: 1rem;
      }
      .react-datepicker__day--selected.react-datepicker__day--disabled {
        background-color: transparent;
      }
      .react-datepicker__month .react-datepicker__month-text,
      .react-datepicker__month .react-datepicker__quarter-text {
        width: 8rem;
        line-height: 4rem;
      }
    }
    .react-datepicker-popper[data-placement="bottom"]
      .react-datepicker__triangle {
      fill: white;
      color: white;
    }
    .react-datepicker__day--keyboard-selected,
    .react-datepicker__month-text--keyboard-selected,
    .react-datepicker__quarter-text--keyboard-selected,
    .react-datepicker__year-text--keyboard-selected {
      color: white;
    }
    .icon-box {
      display: flex;
      position: absolute;
      top: 50%;
      right: 1.25rem;
      transform: translateY(-50%);
    }
  }
`;

export const ConfirmButtonWrapper = styled.div`
  padding: 8px;
  text-align: right;
  border-top: 1px solid #aeaeae;
  background: white;

  button {
    padding: 6px 12px;
    font-size: 14px;
    background-color: #225298;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
`;

export const TotlaMultiBoxWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1.6rem;
  padding: 2.4rem;
  border: 1px solid #cecece;
  border-radius: 0.5rem;
  .box-item {
    border: 1px solid #cecece;
    border-radius: 1rem;
    padding: 1.6rem;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    align-items: center;
    justify-content: center;
    .key {
      color: #575757;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 2.4rem;
    }
    .value {
      color: #242629;
      font-size: 3.2rem;
      font-weight: 700;
      line-height: 4.2rem;
      display: flex;
      gap: 1.6rem;
    }
    .sub {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 0.8rem;
      .comparison-box {
        display: flex;
        gap: 0.8rem;
        align-items: center;
        font-size: 1.6rem;
        line-height: 2.4rem;
        letter-spacing: -0.06rem;
        font-weight: 700;
        &.decrease {
          color: #4683fb;
        }
        &.increase {
          color: #f1414a;
        }
        .icon {
          display: flex;
        }
      }
      .previous {
        display: flex;
        gap: 0.8rem;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: -0.06rem;
        font-weight: 700;
        color: #575757;
      }
    }
    &.active {
      border: 1px solid #242629;
    }
  }
`;
